module.exports = __webpack_public_path__ + "img/icon-hourglass.73896a79.svg";